import { render, staticRenderFns } from "./WorkIconModuleOverview.vue?vue&type=template&id=ad39d08a"
import script from "./WorkIconModuleOverview.vue?vue&type=script&lang=js"
export * from "./WorkIconModuleOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports